import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InlineSVGModule } from 'ng-inline-svg-2';

import { EvrideoCommonModule } from '../common/evrideo-common.module';

// Components
import { LiveSourcesContainerComponent } from './live-sources-container/live-sources-container.component';
import { LiveSourcesToolbarComponent } from './live-sources-toolbar/live-sources-toolbar.component';
import { LiveSourcesGridComponent } from './live-sources-grid/live-sources-grid.component';
import { LiveSourceCardComponent } from './live-source-card/live-source-card.component';

/**
 * Live Sources is eager-loaded via AppModule so that EvrideoCommonModule
 * (ichannel-input, icn-dropdown) is not loaded twice (avoids NG05100).
 * Route is registered in app.routes.ts as a direct component route.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    InlineSVGModule.forRoot(),
    EvrideoCommonModule,
  ],
  declarations: [
    LiveSourcesContainerComponent,
    LiveSourcesToolbarComponent,
    LiveSourcesGridComponent,
    LiveSourceCardComponent,
  ],
  exports: [LiveSourcesContainerComponent],
})
export class LiveSourcesModule {}
